export const TRAVEL_PACKAGES_TEXT = {
    groups: {
        plans: "Планы путешествий",
        bundles: "Готовые наборы путешествий",
    },
    tiers: {
        basic: {
            label: "Базовые",
            subtitle: "Для простых поездок и коротких маршрутов.",
        },
        advanced: {
            label: "Продвинутые",
            subtitle: "Для насыщенных маршрутов и больших компаний.",
        },
        pro: {
            label: "Профи",
            subtitle: "Для сложных путешествий и командной работы.",
        },
    },
    package: "Пакет",
    packages: "Пакеты",
    tripWords: {
        one: "план",
        few: "плана",
        many: "планов",
    },
    features: {
        planItems: "пунктов плана",
        points: "точек маршрута",
        participant: "участник",
        participantsFew: "участника",
        participants: "участников",
        files: "файлов",
        gpxTrack: "GPX-трек",
        gpxTracks: "GPX-треков",
        financeRecords: "финансовых записей",
        aiLimit: "ИИ-лимит",
        credits: "кредитов",
        routeAnimation: "Анимация маршрута",
        map3d: "3D карта",
        noAds: "Без рекламы",
        collaboration: "Совместное редактирование",
        pointPhotos: "До 3 фотографий к каждой точке",
        exportPdf: "Экспорт путешествия в PDF",
    },
    buy: "Купить",
    buyPackage: "Купить пакет",
    bundleFallbackSubtitle: "Готовое пополнение лимита",
    bundleMixedSubtitle: "Пакет из нескольких типов путешествий",
    bundleTouristSubtitle: "Сбалансированный набор всех типов планов для коротких поездок и небольших путешествий.",
    bundleTravelerSubtitle: "Расширенный набор для длительных поездок и насыщенных маршрутов.",
    includes: "Что входит",
    bestChoice: "Лучший выбор",
    popular: "Популярный",
    tariffLimits: "Лимиты тарифа",
    savings: "Экономия",
    loadingCatalog: "Загружаем каталог пакетов...",
    loadErrorTitle: "Не удалось загрузить пакеты",
    retry: "Повторить",
    emptyCatalog: "Пакеты пока не настроены.",
};
